import React, { useEffect, useState } from "react";
import LLMChat from "./LLMChat";
import { useParams } from "react-router-dom";
import { TbReload } from "react-icons/tb";
import EmptyView from "../Platform/ViewComponents/EmptyView";
import { useLanguage } from "../Translations/LenguageContext";
import { FiSmartphone } from "react-icons/fi";
import { MdComputer, MdOpenInBrowser } from "react-icons/md";
import { BiCodeAlt, BiMessage } from "react-icons/bi";
import { PiDatabaseLight } from "react-icons/pi";
import MonacoEditor from '@monaco-editor/react';
import { BsHammer } from "react-icons/bs";



const MainErioonAI = () => {
    const { t } = useLanguage()
    const [userMessage, setUserMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const user_id = sessionStorage.getItem("user_id")
    const { project_id } = useParams()
    const [internetActive, setInternetActive] = useState(false)
    const [defaultView, setDefaultView] = useState("pc")

    const reactHomepage = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>ErioonAI - React Preview</title>
        <style>
          body {
            font-family: 'Arial', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f8fafc;
            color: #333;
          }
          header {
            background-color: #6366f1;
            color: white;
            text-align: center;
            padding: 1rem;
          }
          header h1 {
            margin: 0;
            font-size: 2rem;
          }
          main {
            padding: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 80vh;
          }
          .card {
            padding: 1.5rem;
            border-radius: 10px;
            background: white;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            width: 100%;
            max-width: 400px;
            text-align: center;
          }
          .card h2 {
            font-size: 1.5rem;
            color: #6366f1;
          }
          button {
            padding: 0.5rem 1rem;
            margin-top: 1rem;
            background-color: #6366f1;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 1rem;
          }
          button:hover {
            background-color: #4f46e5;
          }
          footer {
            background-color: #6366f1;
            color: white;
            text-align: center;
            padding: 1rem;
            position: fixed;
            width: 100%;
            bottom: 0;
          }
        </style>
      </head>
      <body>
        <header>
          <h1>Welcome to ErioonAI</h1>
          <p>Your creativity, powered by AI</p>
        </header>
    
        <main>
          <div class="card">
            <h2>Interactive React Component</h2>
            <p>You clicked <span id="clickCount">0</span> times.</p>
            <button id="clickButton">Click Me</button>
          </div>
        </main>
    
        <footer>
          <p>&copy; 2025 ErioonAI | All rights reserved</p>
        </footer>
    
        <!-- Load React and ReactDOM from CDN -->
        <script src="https://unpkg.com/react@18/umd/react.development.js"></script>
        <script src="https://unpkg.com/react-dom@18/umd/react-dom.development.js"></script>
        <script>
          const { useState } = React;
    
          function App() {
            const [count, setCount] = useState(0);
    
            return (
              React.createElement("div", { className: "card" },
                React.createElement("h2", null, "Interactive React Component"),
                React.createElement("p", null, "You clicked ", count, " times."),
                React.createElement("button", { onClick: () => setCount(count + 1) }, "Click Me")
              )
            );
          }
    
          const root = ReactDOM.createRoot(document.getElementById("root"));
          root.render(React.createElement(App));
        </script>
      </body>
    </html>
    `;



    const [displayedText, setDisplayedText] = useState("");

    const title_empty = "Imagine. Write. Build."
    const subtitle_empty = "ErioonAI takes your creativity to another level: build anything in seconds."
    const img_empty = "/IMG/chat_laptop.png"

    const sendMessage = async () => {
        if (!userMessage) return;

        const newUserMessage = { text: userMessage, sender: "user" };
        setMessages([...messages, newUserMessage]);
        setUserMessage("");
        setIsLoading(true);

        const analyzingMessage = { text: "Loading_message", sender: "ai", isCode: false };
        setMessages((prevMessages) => [...prevMessages, analyzingMessage]);

        try {
            const response = await fetch("https://backend.erioon.com/start_llm_chat", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ message: userMessage, user_id: user_id, project_id: project_id }),
            });

            const data = await response.json();
            const newAiMessage = {
                text: data.response,
                sender: "ai",
                isCode: data.is_code,
            };

            setMessages((prevMessages) => [
                ...prevMessages.slice(0, -1),
                newAiMessage,
            ]);

            startWordByWordAnimation(newAiMessage.text);

        } catch (error) {
            console.error("Error sending message:", error);
            setMessages((prevMessages) => [
                ...prevMessages.slice(0, -1),
                { text: "Error fetching response.", sender: "ai", isCode: false },
            ]);
        } finally {
            setIsLoading(false);
        }
    };

    const startWordByWordAnimation = (text) => {
        const words = text.split(" ");
        let index = 0;
        const intervalId = setInterval(() => {
            if (index < words.length) {
                setDisplayedText((prevText) => prevText + (index === 0 ? words[index] : " " + words[index]));
                index++;
            } else {
                clearInterval(intervalId); // Stop the interval once all words are displayed
            }
        }, 850); // Adjust the time between words as needed
    };


    const GetMessages = async () => {
        try {
            const response = await fetch("https://backend.erioon.com/get_llm_chat", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user_id, project_id: project_id }),
            });

            const data = await response.json();
            const chatThread = data.ai_chat;
            console.log(chatThread)
            if (chatThread) {
                const flattened = chatThread.flatMap(entry => entry.messages);
                setMessages(flattened);
            } else {
                setMessages([])
            }
        } catch (error) {
            console.error("Error getting chat:", error);
            setMessages([{ text: "Error loading chat history.", sender: "ai", isCode: false }]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (user_id) {
            GetMessages();
        } else {
            setIsLoading(false);
        }
    }, [user_id]);


    const handleEditorChange = (value, event) => {
        // setCodeSnippet(value);
    };

    return (
        <div className="erioon_ai_container_main">
            <div className={`erioon_ai_container_main_header`}>
                <div className="erioon_ai_container_inner">
                    <div className="erioon_ai_container_inner_block">
                    </div>
                    <div className="erioon_ai_container_inner_block">
                        <button className="erioon_ai_container_btn"><BiMessage /> Clear</button>
                    </div>
                </div>
                <div className="erioon_ai_container_inner">
                    <div className="erioon_ai_container_inner_block">
                        <button className="erioon_ai_container_btn"><PiDatabaseLight /></button>
                        <button className="publish_btn_erioon_ai_container">PUBLISH</button>
                    </div>
                    <div className="erioon_ai_container_inner_block">
                        <div className="erioon_ai_container_inner_switch">
                            <div className={`erioon_ai_container_switch ${defaultView === "phone" ? "erioon_ai_container_switch_selected" : ""}`} onClick={() => setDefaultView("phone")}><FiSmartphone /></div>
                            <div className={`erioon_ai_container_switch ${defaultView === "pc" ? "erioon_ai_container_switch_selected" : ""}`} onClick={() => setDefaultView("pc")}><MdComputer /></div>
                            <div className={`erioon_ai_container_switch ${defaultView === "code" ? "erioon_ai_container_switch_selected" : ""}`} onClick={() => setDefaultView("code")}><BiCodeAlt /></div>
                        </div>
                    </div>
                    <div className="erioon_ai_container_inner_block">
                        <button className="erioon_ai_container_btn"><TbReload /></button>
                        <button className="erioon_ai_container_btn"><MdOpenInBrowser /></button>
                    </div>
                </div>

            </div>
            <div className="erioon_ai_container">
                <div className={`erioon_ai_chat_container`}>
                    <LLMChat
                        userMessage={userMessage}
                        messages={messages}
                        isLoading={isLoading}
                        user_id={user_id}
                        sendMessage={sendMessage}
                        setUserMessage={setUserMessage}
                        setInternetActive={setInternetActive}
                        internetActive={internetActive}
                    />
                </div>
                <div className={`erioon_ai_live_container`}>
                    <div className="empty_cont">
                        <div className="icon_cont">
                            <p className="icon_cont_title">{title_empty}</p>
                            <p className="icon_cont_subtitle">{subtitle_empty}</p>

                            {img_empty != "" && (
                                <img className="icon_img" src={img_empty} />
                            )}
                            <p className="icon_cont_subtitle">(This section is currently under developement)</p>

                        </div>
                    </div>
                    {/* {messages.length <= 0 ? (
                        <EmptyView
                            navigate_link={""}
                            title={title_empty}
                            subtitle={subtitle_empty}
                            img_src={img_empty}
                        />
                    ) : (
                        <>
                            {defaultView == "pc" ? (

                                <>
                                    <iframe
                                        title="preview"
                                        srcDoc={reactHomepage}
                                        sandbox="allow-scripts allow-same-origin"
                                        style={{ width: '100%', height: '100%', border: 'none' }}
                                    />
                                </>
                            ) : defaultView == "phone" ? (
                                <></>
                            ) : (
                                <div className="live_preview_code_ide">
                                    <div className="live_preview_code_ide_sidebar">
                                        <div className="live_preview_code_ide_sidebar_link">Reactcomponent.js</div>
                                        <div className="live_preview_code_ide_sidebar_link"></div>
                                        <div className="live_preview_code_ide_sidebar_link"></div>

                                    </div>
                                    <div className="live_preview_code_ide_body_cont">
                                        <div className="live_preview_code_ide_header">
                                            <button className="erioon_ai_container_btn">Save</button>
                                        </div>
                                        <div className="live_preview_code_ide_body">
                                            <MonacoEditor
                                                className="query_editor_input"
                                                height="100%"
                                                width="100%"
                                                language="javascript"
                                                onChange={handleEditorChange}
                                                defaultValue="# Print python"
                                            />
                                        </div>
                                    </div>

                                </div>
                            )}
                        </>
                    )} */}

                </div>
            </div>
        </div>
    )
}

export default MainErioonAI